import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'react-bootstrap-5';

import ManagedInput from 'components/form/managed_input';
import PropertyType from './property_type';

import './styles.scss';

export default function CompanyGridPropertyTypes({ companyGrid, onChange }) {
  return <React.Fragment>
    <Card>
      <Card.Body>
        <ManagedInput
          checked={companyGrid.createShadowOnPropertyCreate}
          name="createShadowOnPropertyCreate"
          type="checkbox"
          onChange={onChange}
        >
          Auto-create grid for new listings of the selected property type(s)
        </ManagedInput>
      </Card.Body>
    </Card>

    <Card>
      <Card.Body className="company-grid-property-types-panel overflow-y-auto" style={{ maxHeight: 386 }}>
        {Object.values(companyGrid.propertyTypesById).map(propertyType => (
          <PropertyType
            key={propertyType.id}
            propertyType={propertyType}
            onChange={propertyType => onChange({
              propertyTypesById: {
                ...companyGrid.propertyTypesById,
                [propertyType.id]: propertyType,
              }
            })}
          />
        ))}
      </Card.Body>
    </Card>
  </React.Fragment>;
}

CompanyGridPropertyTypes.propTypes = {
  companyGrid: PropTypes.shape({
    createShadowOnPropertyCreate: PropTypes.bool,
    propertyTypesById: PropTypes.objectOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
  }).isRequired,
  onChange: PropTypes.func,
};
